import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter, ViewChild, OnChanges, Renderer2, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { LoadingComponent } from '../../../shared/components/loading/loading.component';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'product-calendar',
    providers: [

    ],
    templateUrl: './product-calendar.component.html',
    styleUrls: ['./product-calendar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductCalendarComponent implements OnChanges, OnInit{
    public now:Date = new Date();
    public start:Date;
    public lastDay:string;
    public isReady:boolean = false;
    public days = [];
    public monthBtn;
    public todayCSS:boolean;
    public selectCSS:boolean;
    @Input() dateSelected:Date;
    @Input() availableDays: any[];
    @Input() firstDayAvailable: string;
    @Input() changeMonth: string;
    @Input() isWaiting:boolean = false;
    @Output() onChangeDates: EventEmitter<any> = new EventEmitter();
    @Output() getDays:EventEmitter<any> = new EventEmitter();

    @Input() date: any;
    @Output() dateChanged: EventEmitter<any> = new EventEmitter();

    @ViewChild('loadUnits') loadingComponentUnits:LoadingComponent;

    constructor(private adapter: DateAdapter<any>,private translate:TranslateService,private renderer: Renderer2, private el: ElementRef){ }

    ngOnInit(){
        let lng = this.translate.currentLang;
        switch (lng) {
            case 'en':
                this.adapter.setLocale('en')
                break;
            case 'fr':
                this.adapter.setLocale('fr')
                break;
            case 'es':
                this.adapter.setLocale('es')
                break;
            case 'it':
                this.adapter.setLocale('it')
                break;
            case 'de':
                this.adapter.setLocale('de')
                break;
            default:
                this.adapter.setLocale('en')
                break;
        }

        if(this.firstDayAvailable){
            this.start = new Date(this.firstDayAvailable);
            this.now = new Date(this.firstDayAvailable);
        }

        if(!this.monthBtn){
            setTimeout(() => {
                this.monthBtn = this.el.nativeElement.querySelector('.mat-button.mat-calendar-period-button');
                if (this.monthBtn) { 
                    this.renderer.setAttribute(this.monthBtn, 'disabled',"true");
                }
            }, 100);
        }
    }

    ngOnChanges(){
        if(this.start != this.dateSelected ){
            this.selectCSS = false;
            this.todayCSS = true;
        } else {
            this.todayCSS = false;
            this.selectCSS = true;
        }
        if(this.availableDays){
            this.availableDays.map(day => {
                this.days.push(day)
            });
        }
        if(this.isWaiting){
            this.isReady = true;
            this.loadingComponentUnits.setHidden(true);
        }
    }

    myFilter = (d: Date): boolean => {
        let datePipe = new DatePipe("en-US");
        const date = datePipe.transform(d, 'yyyy-MM-dd')
        if (date == this.changeMonth) {
            this.getDays.emit({ date: date });
            this.isReady = false;
            this.loadingComponentUnits.setHidden(false);
        }
        if (this.days.find(x => x == date)) {
            return true;
        } else {
            return false;
        }
    }

    changeDate(e) {
        this.onChangeDates.emit(e);
    }
}